import { render, staticRenderFns } from "./BookingClientCancelReasonModal.vue?vue&type=template&id=188fcabe"
import script from "./BookingClientCancelReasonModal.vue?vue&type=script&lang=js"
export * from "./BookingClientCancelReasonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports